import React from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar, BottomNav } from "../components/Shell";
import Ico from "../components/Ico";
import { lessons } from "../mock";
import { ChevronLeft, GraduationCap, CheckCircle2, Play, Sparkles } from "lucide-react";

export default function Academy() {
  const navigate = useNavigate();
  const doneCount = lessons.filter((l) => l.done).length;
  const pct = Math.round((doneCount / lessons.length) * 100);

  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0 px-5 pb-6" style={{ background: "linear-gradient(160deg,#8b5cf6,#6b3fd0)", borderBottomLeftRadius: 28, borderBottomRightRadius: 28 }}>
        <StatusBar dark={false} />
        <div className="mt-1 flex items-center gap-2">
          <button onClick={() => navigate(-1)} className="gd-tap grid h-10 w-10 place-items-center rounded-full bg-white/15"><ChevronLeft size={20} color="#fff" /></button>
          <div className="flex items-center gap-2 text-white"><GraduationCap size={22} /><h1 className="text-2xl font-extrabold">Money Academy</h1></div>
        </div>
        <div className="mt-4 rounded-2xl bg-white/15 p-4">
          <div className="flex items-center justify-between text-white"><span className="text-sm font-bold">Your Progress</span><span className="text-sm font-extrabold">{doneCount}/{lessons.length} lessons</span></div>
          <div className="mt-2 h-2.5 rounded-full bg-white/25"><div className="h-2.5 rounded-full bg-white" style={{ width: `${pct}%` }} /></div>
        </div>
      </div>

      <div className="gd-scroll px-4 py-4 gd-stagger">
        <div className="mb-3 flex items-center gap-2 rounded-2xl bg-[#efe9fb] p-3 text-[12px] font-semibold text-[#7c4fd0]">
          <Sparkles size={16} /> Finish lessons to earn XP and build real financial literacy.
        </div>
        <div className="space-y-3">
          {lessons.map((l) => (
            <div key={l.title} className="gd-card flex items-center gap-3 p-4">
              <div className="grid h-12 w-12 flex-shrink-0 place-items-center rounded-2xl" style={{ background: l.done ? "#eaf6ea" : "#efe9fb" }}>
                <Ico name={l.icon} size={22} color={l.done ? "#4fae3f" : "#8b5cf6"} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-extrabold text-[#1f2a52]">{l.title}</p>
                <p className="truncate text-[11px] font-semibold text-[#9aa3c0]">{l.desc}</p>
                <p className="mt-0.5 text-[10px] font-bold text-[#8b5cf6]">+{l.xp} XP · {l.mins} min</p>
              </div>
              {l.done ? (
                <CheckCircle2 size={26} className="text-[#4fae3f]" />
              ) : (
                <button className="gd-tap grid h-10 w-10 place-items-center rounded-full" style={{ background: "linear-gradient(180deg,#9a6ff7,#7c4fd0)" }}><Play size={16} color="#fff" fill="#fff" /></button>
              )}
            </div>
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
